import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { INFO_PAGE_LINKS } from "../InfoPages/infoPagesConfig";

export default function Footer() {
    const { t } = useTranslation();
    const iconBase = process.env.PUBLIC_URL || '';

    return (
        <footer className="footy-sec mn no-margin info-footer">
            <div className="container info-footer__container">
                <nav className="info-footer__links" aria-label="Information pages">
                    {INFO_PAGE_LINKS.map((link, index) => (
                        <Fragment key={link.slug}>
                            <Link className="info-footer__link" to={`/info/${link.slug}`}>
                                {t(link.labelKey)}
                            </Link>
                            {index !== INFO_PAGE_LINKS.length - 1 && (
                                <span className="info-footer__divider">|</span>
                            )}
                        </Fragment>
                    ))}
                </nav>
                <div className="info-footer__meta">
                    <p>
                        <a href="https://www.linkedin.com/in/moussadiallo14/" target="_blank" rel="noreferrer">
                            © 2025 MEANC Technologies – All Rights Reserved
                        </a>
                    </p>
                    <img
                        className="info-footer__logo"
                        src={`${iconBase}/images/img2/meanclogo5.png`}
                        alt="Meanc"
                    />
                </div>
            </div>
        </footer>
    );
}
